import { React } from 'react';
import { useEffect, useState, useRef } from 'react';
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";
import { createPaypalOrder, approveOrder, paymentIntent, setBookingRequestStatus } from "../api/api";
import { loadStripe } from '@stripe/stripe-js';
import { strings } from '../localization/strings';

// This value is from the props in the UI
const style = {"layout":"horizontal", "color": "white", "tagline": false};
const stripePromise = loadStripe('pk_live_51MzcZuKOJfMiKM411lOmoVe0HiFp95SCgFzUotFkTh4bUBP2GYuDKvaYCJDtwKIYqdMKtneq31XG0ZNrQwVQZIQy00j71di3lB');

function PaymentButtons({ availability, adult, child, bookingRequestId, transactionId, thankYouPage, language }) {

  const [totalPrice, setTotalPrice] = useState('0,00');
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const [adultTariff, setAdultTariff] = useState(0);
  const [childTariff, setChildTariff] = useState(0);
  const [entranceFeeAdultTariff, setEntranceFeeAdultTariff] = useState(0);
  const [adultPrice, setAdultPrice] = useState(0);
  const [childPrice, setChildPrice] = useState(0);
  const [entranceFee, setEntranceFee] = useState(0);
  const [adultChild, setAdultChild] = useState(0);
  const [paypalSelected, setPaypalSelected] = useState(false);
  const [cardSelected, setCardSelected] = useState(false);
  const [enableProceed, setEnableProceed] = useState(false);
  const [elements, setElements] = useState(null);
  const [showErrorTransaction, setShowErrorTransaction] = useState(false);
  const showErrorTransactionRef = useRef(showErrorTransaction);
  showErrorTransactionRef.current = showErrorTransaction;

  const translation = strings[language] ?? strings.it;

  function createOrder() {
      // replace this url with your server
      return createPaypalOrder(bookingRequestId)
          .then((response) => {
            return response.data;
          })
          .then((order) => {
              // Your code here after create the order
              return order.id;
          });
  }
  function onApprove(data) {
    return approveOrder(data).then(() => {
      setShowErrorTransaction(false);
      window.location.href = thankYouPage;
    }).catch(() => {
      setShowErrorTransaction(true);
      setBookingRequestStatus(bookingRequestId, 'errorPayment');
    });
  }

  function onError(err) {
    setShowErrorTransaction(true);
    setBookingRequestStatus(bookingRequestId, 'errorPayment');
  }

  const clickNextStep = () => {
    if (!enableProceed) {
      return;
    }

    if (paypalSelected) {
      return;
    }

    setShowErrorTransaction(false);

    // confirm payment with stripe
    stripePromise.then((stripe) => {
      stripe.confirmPayment({
        elements: elements,
        confirmParams: {
          return_url: thankYouPage,
        }
      }).then((result) => {
        if (result.error) {
          setShowErrorTransaction(true);
          setBookingRequestStatus(bookingRequestId, 'errorPayment');
        }
      });
    }, () => {
      setShowErrorTransaction(true);
      setBookingRequestStatus(bookingRequestId, 'errorPayment');
    });
  };

  const clickCard = () => {
    setEnableProceed(false);

    if (cardSelected) {
      setCardSelected(false);
      return;
    }
    if (paypalSelected) {
      setPaypalSelected(false);
    }
    setCardSelected(true);

    paymentIntent(totalPrice, transactionId, bookingRequestId).then((result) => {
      stripePromise.then((stripe) => {
        const elems = stripe.elements({ theme: 'stripe', clientSecret: result.data.clientSecret, locale: language });
        setElements(elems);
        const paymentElement = elems.create('payment', {
          paymentMethodOrder: ['card'],
          layout: {
            type: 'accordion',
            visibleAccordionItemsCount: 1
          },
          defaultValues: {
            billingDetails: {
              transactionId: transactionId
            }
          }
        });
        paymentElement.mount('#stripe-elements');
        setTimeout(() => {
          paymentElement.on('change', (event) => {
            setEnableProceed(event.complete);
            if (showErrorTransactionRef.current && event.complete) {
              setShowErrorTransaction(false);
            }
          });
        }, 0);
      });
      
    }).catch(() => {
    });
  };

  const ButtonWrapper = () => {
      usePayPalScriptReducer();

      return (
          <>
              <PayPalButtons
                  style={style}
                  fundingSource={undefined}
                  createOrder={createOrder}
                  onApprove={onApprove}
                  onError={onError}
              />
          </>
      );
  }

  useEffect(() => {
    if (availability && availability.tariff) {
        const adultPriceCalc = availability.tariff.adult * adult;
        setAdultPrice(adultPriceCalc.toFixed(2).replace('.', ','));
        setAdultTariff(availability.tariff.adult.toFixed(2).replace('.', ','));
        const childPriceCalc = availability.tariff.reduced * child;
        setChildPrice(childPriceCalc.toFixed(2).replace('.', ','));
        setChildTariff(availability.tariff.reduced.toFixed(2).replace('.', ','));
        let total = adultPriceCalc + childPriceCalc;

        if (availability.entranceFee) {
            const entranceFeeCalc = availability.entranceFee.adult * adult + availability.entranceFee.reduced * child;
            setEntranceFeeAdultTariff(availability.entranceFee.adult.toFixed(2).replace('.', ','));
            setEntranceFee(entranceFeeCalc.toFixed(2).replace('.', ','));
            setAdultChild(parseInt(adult) + parseInt(child));
            total = total + entranceFeeCalc;
        }

        // show the total price with 2 decimal digits
        total = total.toFixed(2).replace('.', ',');
        setTotalPrice(total);
    }
  }, [availability, adult, child]);

    return (
      <div className="recap-container">
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
          <div className="recap-column recap-payment">
            <div className="tourmaster-payment-total" style={{marginBottom: '20px'}}>
              <div className="tourmaster-payment-total-title" style={{padding: '10px'}}>Totale:
                    <h5 className="tourmaster-tour-price-wrap" style={{display: 'inline', marginLeft: '10px'}}>{totalPrice}€</h5>
              </div>
            </div>
            <div className="recap-price-detail-container" onClick={() => { setShowPriceDetail(!showPriceDetail) }}>
                {translation.priceDetails}
                <span className="fa fa-solid fa-caret-down" style={{float: 'right', color: '#fe3956', paddingTop: '5px' }}></span>
            </div>
            {showPriceDetail && <div className="recap-column recap-price-detail">
                <div className="recap-row">
                    <div style={{flex: 2}}>{translation.adults}</div>
                    <div style={{flex: 1, textAlign: 'end'}}>{adultTariff}€</div>
                    <div style={{flex: 1, textAlign: 'end'}}>x {adult}</div>
                    <div style={{flex: 2, textAlign: 'end'}}>= {adultPrice}€</div>
                </div>
                <div className="recap-row">
                    <div style={{flex: 2}}>{translation.children}</div>
                    <div style={{flex: 1, textAlign: 'end'}}>{childTariff}€</div>
                    <div style={{flex: 1, textAlign: 'end'}}>x {child}</div>
                    <div style={{flex: 2, textAlign: 'end'}}>= {childPrice}€</div>
                </div>
                <div className="recap-row">
                    <div style={{flex: 2}}>{translation.AMPTax}</div>
                    <div style={{flex: 1, textAlign: 'end'}}>{entranceFeeAdultTariff}€</div>
                    <div style={{flex: 1, textAlign: 'end'}}>x {adultChild}</div>
                    <div style={{flex: 2, textAlign: 'end'}}>= {entranceFee}€</div>
                </div>
                <div className="recap-separator" style={{ height: '1px', background: '#ccc', margin: '10px 0' }}></div>
                <div className="recap-row">
                    <div style={{flex: 2}}>{translation.totalShort}:</div>
                    <div style={{flex: 1}}></div>
                    <div style={{flex: 1}}></div>
                    <div style={{flex: 2, textAlign: 'end'}}> = {totalPrice}€</div>
                </div>
            </div>}
          </div>
          <div className="recap-column recap-payment">
            <div className="recap-price-detail-container" style={{marginBottom: '20px'}} onClick={() => { clickCard() }}>
            <span className={"fa fa-regular " + (cardSelected ? 'fa-circle-check' : 'fa-circle')} style={{marginRight: '10px'}}></span>
              {translation.creditCard}
              <img
                src="./Mastercard-Logo.png"
                alt="master-card"
                style={{float: 'right'}}
              />
              <img
                src="./visa.png"
                alt="visa"
                style={{float: 'right'}}
              />
            </div>
            { cardSelected && <div id="stripe-elements" style={{marginBottom: '20px'}}></div> }
            <div className="recap-price-detail-container" style={{marginBottom: '20px'}} onClick={() => { setEnableProceed(!paypalSelected); setPaypalSelected(!paypalSelected); if (cardSelected) { setCardSelected(false) } }}>
              <span className={"fa fa-regular " + (paypalSelected ? 'fa-circle-check' : 'fa-circle')} style={{marginRight: '10px'}}></span>
              PayPal
              <img
                src="./paypal.png"
                alt="paypal"
                style={{float: 'right'}}
              />
            </div>
          </div>
          <a className={"tourmaster-button " + (enableProceed ? "" : "disabled")} onClick={() => { clickNextStep() }}
            style={{borderRadius: '20px', marginTop: '20px', width: '100%', textAlign: 'center', zIndex: 1000, position: 'relative', pointerEvents: (paypalSelected ? 'none' : '')}} >
              {translation.paymentCallToAction} <span className="fa fa-regular fa-face-smile" style={{marginLeft: '10px'}}></span>
            </a>
          <div style={{position: 'relative', top: "-50px", zIndex: 0, height: '44px', overflow: 'hidden', borderRadius: '30px', width: '100%'}}>
            <PayPalScriptProvider options={{
                clientId: "AQ01RuitcZ3GYSdEqjTBX2YL3O87GSi4S5fuZBaIqCNLEydW-czQQNAzcAxWtPe6CinttL8jEB6CUKRP",
                components: "buttons",
                currency: "EUR",
                disableFunding: "credit,card,mybank,sofort,eps"
                }}>
                    <ButtonWrapper/>
            </PayPalScriptProvider>
          </div>
          { showErrorTransaction &&
            <div className="recap-column" style={{color: '#fe3956'}}>
              <span className='fa fa-regular fa-circle-xmark'/>
              <div className="tour-booking-submit-error">{translation.errorTransaction}</div>
            </div>
          }
          <div className="recap-column" style={{width: '100%'}}>
              * {translation.freeCancellation}
            </div>       
        </div>
      </div>
    );
}

export default PaymentButtons;
